import React from 'react';

import { Button, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { IconReportSearch } from '@tabler/icons-react';

interface IWorkHoursEmptyStateProps {
  onLogWorkClick: () => void;
}

const WorkHoursEmptyState = ({ onLogWorkClick }: IWorkHoursEmptyStateProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Stack align='center' spacing='xs' py='xl'>
      <IconReportSearch size={48} color={theme.colors.gray[5]} />
      <Title order={4}>Start logging hours</Title>
      <Text color='dimmed' size='sm'>
        Keep track of the work by adding a first entry.
      </Text>
      <Button onClick={onLogWorkClick} mt='sm'>
        Log Work
      </Button>
    </Stack>
  );
};

export default WorkHoursEmptyState;
